<template>
  <div>
    <v-card flat>
      <v-card-text>
        <div class="flex my-4 mb-4">

          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">CPD Activity Provider:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.cpdProvider ? values.cpdProvider.trainingCenterName : "-" }}
            </div>
          </div>

          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">CPD Activity Type:</p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.programType.name ? values.programType.name : "-" }}
            </div>
          </div>
        </div>

        <div class="flex my-4 mb-4">

          <div class="w-1/3 h-12">
            <p class="text-md-left font-weight-bold">
              CPD Activity Category:
            </p>
          </div>
          <div class="w-1/3 h-12">
            <div class=".text-base">
              {{ values.category ? values.category.name : "-" }}
              <span v-if="values.category" class="font-weight-medium">{{
                  values.category.categoryType === "CAT2"
                      ? "(Category 2)"
                      : "(Category 1)"
                }}</span>
            </div>
          </div>
          <div class="w-1/3 h-12"></div>
          <div class="w-1/3 h-12"></div>
        </div>
      </v-card-text>
    </v-card>

    <v-tabs>
      <v-tab>Course</v-tab>

      <v-tab-item>
        <div>
          <v-card flat>
            <v-card-text>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">Course Name:</p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.courseTitleCat2 ? values.courseTitleCat2 : (values.program_courses.length !== 0 ? values.program_courses[0].course.courseName : "-")
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Continuing Education Unit:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.courseLevel ? values.courseLevel.name : (values.program_courses.length !== 0 ? values.program_courses[0].course.continualEducationUnit : "-")
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Course Level:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.ceu ? values.ceu : (values.program_courses.length !== 0 ? values.program_courses[0].course.continualEducationUnit : "-")
                    }}
                  </div>
                </div>
              </div>
              <div class="flex my-4 mb-4">
                <div class="w-1/3 h-12">
                  <p class="text-md-left font-weight-bold">
                    Passing Score:
                  </p>
                </div>
                <div class="w-1/3 h-12">
                  <div class=".text-base">
                    {{
                      values.cat2PassingScore ? values.cat2PassingScore : (values.program_courses.length !== 0 ? values.program_courses[0].course.continualEducationUnit : "-")
                    }}
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </div>
      </v-tab-item>

      <v-tab>General Activity Information</v-tab>

      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <div class="flex my-4 mb-4">
              <div class="w-1/3 h-12">
                <p class="text-md-left font-weight-bold">Facilitated By:</p>
              </div>
              <div class="w-1/3 h-12">
                <p class="font-weight-medium">
                  {{ values.facilitatedBy ? values.facilitatedBy : "-" }}
                </p>
              </div>

              <div class="w-1/3 h-12">
                <p class="text-md-left font-weight-bold">
                  Participants Number:
                </p>
              </div>
              <div class="w-1/3 h-12">
                <p class="font-weight-medium">
                  {{
                    values.participantsNumber ? values.participantsNumber : "-"
                  }}
                </p>
              </div>
            </div>

            <div class="flex my-4 mb-4">
              <div class="w-1/3 h-12">
                <p class="text-md-left font-weight-bold">Start Date:</p>
              </div>
              <div class="w-1/3 h-12">
                <div class=".text-base">
                  {{ values.startDate ? values.startDate : "-" }}
                </div>
              </div>
              <div class="w-1/3 h-12">
                <p class="text-md-left font-weight-bold">End Date:</p>
              </div>
              <div class="w-1/3 h-12">
                <div class=".text-base">
                  {{ values.endDate ? values.endDate : "-" }}
                </div>
              </div>
            </div>

            <div class="flex my-4 mb-4">
              <div class="w-1/3 h-12">
                <p class="text-md-left font-weight-bold">Activity Delivery:</p>
              </div>
              <div class="w-1/3 h-12">
                <p class="font-weight-medium">
                  {{ values.activityDelivery ? values.activityDelivery.name : "-" }}
                </p>
              </div>
              <div class="w-1/3 h-12">
                <p class="text-md-left font-weight-bold">Trainers Number:</p>
              </div>
              <div class="w-1/3 h-12">
                <div class=".text-base">
                  {{ values.trainersNumber ? values.trainersNumber : "-" }}
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- <v-tab>Training Center</v-tab> -->

      <!-- <v-tab-item>
      <v-card flat>
        <v-card-text>
          <div class="flex my-4 mb-4">
            <div class="w-1/3 h-12">
              <p class="text-md-left font-weight-bold">Training Center Name:</p>
            </div>
            <div class="w-1/3 h-12">
              <div class=".text-base">{{ values.courseName ? values.courseName :''}}</div>
            </div>
          </div>
          <div class="flex my-4 mb-4">
            <div class="w-1/3 h-12">
              <p class="text-md-left font-weight-bold">Location:</p>
            </div>
            <div class="w-1/3 h-12">
              <div class=".text-base">{{values.courseDescription ? values.courseDescription : '' }}</div>
            </div>
          </div>
          <div class="flex my-4 mb-4">
            <div class="w-1/3 h-12">
              <p class="text-md-left font-weight-bold">CPD Provides:</p>
            </div>
            <div class="w-1/3 h-12">
              <div class=".text-base">{{ values.creditHour ? values.creditHour :''}}</div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-tab-item>-->
    </v-tabs>
  </div>
</template>


<script>
export default {
  props: {
    program: Object,
  },
  data() {
    return {
      values: [],
    };
  },
  created() {
    if (this.program != null) {
      this.values = this.program;
      console.log('value', this.values);
    }
  },
};
</script>
<style>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>